import { configureStore } from "@reduxjs/toolkit";
import gamamobilityReducer from "./strapi/index";

const store = configureStore({
  reducer: {
    gamamobility: gamamobilityReducer,
  },
});

export default store;
